import React from 'react';

import { getNodeProperties } from '../../../../utils/editor.utils';
import EntityModel from '../ExpressionModal/EntityModel';

export const ExpandableComponent = ({ row }) => {
  const { translations, entityDefinition, editRow } = row;

  const onUpdateValue = (obj) => {
    if (obj.caption) {
      const { properties } = getNodeProperties(entityDefinition, obj.nodeProperties.nodeId, false);
      const translationForEntity = translations[properties.Caption];
      const newValue = {
        translatedUpdateFrom: row.translatedUpdateFrom,
        source: row.source,
        updateFrom: row.updateFrom,
        updateToType: properties.DataType,
        updateTo: obj.nodeProperties.valueCaption,
        translatedUpdateTo: translationForEntity,
      };
      editRow(row.id, newValue, true);
    }
  };

  return (
    <div>
      <EntityModel
        action={true}
        allowEntity={true}
        showSearch
        change={onUpdateValue}
        height={300}
        width={500}
      />
    </div>
  );
};
